import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h

export default {
    name: 'kendo-buttongroup-button',
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement

        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ?
            this.$slots.default() : this.$slots.default
        return h('li', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/KendoButtonGroupButton.js